import React from 'react';
import styled from 'styled-components';
import Progress from '../Progress/Progress'

const ProgressWrapper = styled.div`
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 1000;
`;

type QuizProgressBarProps = {
    percent?: number | undefined
}

const QuizProgressBar: React.FC<QuizProgressBarProps> = ({
    percent,
 }) => {
    return <ProgressWrapper><Progress percent={percent} big transparent /></ProgressWrapper>
}

export default QuizProgressBar